/**
 * Created by Thomas Mark
 * Date: 2021-04-02
 * 
 * In diesem Dialog hat der Benutzer die Möglichkeit Details zu den 
 * Produkten zu erfassen. 
 * 
 * Der Dialog besteht aus zwei Listen:
 * - Liste links  - Liste mit allen verfügbaren Produktdetails (Icons-Tabelle).
 *                  Hier können Produktdetails bzw. Produkteigenschaften ausgewählt
 *                  werden und in die Liste rechts übernommen werden.
 * 
 * - Liste rechts - Liste mit Produktdetails die einem Produkt zugeordnet sind.
 *                  Diese Liste enthält alle Produktdetails bzw. Produkteigenschaften
 *                  die dem aktuellen Produkt bereits zugeordnet wurden.
 * 
 * In der Liste rechts können die Details direkt editiert werden, sodass ein Wert und eine 
 * Mengeneinheit zum Produktdetails zugeordnet werden kann.
 * 
 * Die Liste rechts hat folgenden Aufbau:
 * +---------------+------+---------------+------+
 * | Eigenschaft   | icon |          Wert | Unit |
 * +---------------+------+---------------+------+
 * | Tragfähigkeit | icon |         10000 | kg   |
 * +---------------+------+---------------+------+
 * | Baureihe      | icon |        BR1133 |      |
 * +---------------+------+---------------+------+
 * 
 * Die Eigenschaft kann über ein Autocomplete-Feld eingegeben werden.
 * In Abhängigkeit vom der Eigenschaft wird das Icon automatisch angezeigt.
 * Der Wert wird ebenfalls als Beispiel-Wert voreingestellt, sofern ein 
 * beispielwert hintertlegt wurde. 
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

import { ModalTitle } from "../../partials/ModalTitle";
import * as utils from "../../../basics/utils";
import * as appActions from "../../../store/actions/appActions";
import * as fileActions from "../../../store/actions/fileActions";
import * as iconActions from "../../../store/actions/iconActions";
import * as portfolioActions from "../../../store/actions/portfolioActions";

/* ag-grid-react */
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';

const styles = (theme) => ({
    root: {
        padding: theme.spacing(2),
        backgroundColor: 'gray',
        color: 'white'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    form: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1)
        },
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        marginTop: theme.spacing(1),
        minWidth: 500,
    },
    message: {
        color: 'rgb(238,60,54)'
    }
})
class ProductDetailsModal extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;

        this.component = 'ProductDetailsModal';

        this.initMeta = {
            subTitle: '',
            description: '',
            url: '',
            tags: {
                theme: [],
                product: []
            },
            details: []
        };

        this.state = {
            newMeta: this.initMeta
        }

        this.meta = {};

        this.dataLeft = [];
        this.dataRight = [];
        this.iconListFiltered = [];

        this.agGridLeftApi = null;
        this.agGridLeftColumnApi = null;
        this.agGridLeftWidth = 400;
        this.agGridLeftVisibleItems = 10;

        this.agGridRightApi = null;
        this.agGridRightColumnApi = null;
        this.agGridRightWidth = 500;
        this.agGridRightVisibleItems = 5;

        this.agGridRowHeight = 40;
        this.agGridHeaderHeight = 40;

        this.currentProduct = null;
    }

    // ==========================================================================
    //
    // LIFESYCLE - SECTION
    //
    // ==========================================================================
    loadDataLeft = () => {
        const { iconList } = this.props.icon;

        this.iconListFiltered = iconList.filter((d) => d.type === 'product');

        this.dataLeft = this.iconListFiltered;
    }

    loadDataRight = () => {
        if (this.currentProduct === null) return;

        const metaList = this.currentProduct.children.filter(d => d.name === 'meta.json')
        if (metaList.length > 0) {
            //console.log('meta.json gefunden!')
            const meta = metaList[0].meta;

            this.newMeta = meta;
            this.dataRight = meta.details;

        } else {
            //console.log('meta.json existiert nicht!');
            this.dataRight = [];
            this.newMeta = this.initMeta;
        }

        this.setState({ newMeta: this.newMeta })
    }

    componentDidUpdate(prevProps) {
        //console.log('componentDidUpdate()', this.component)
        const { modalDialog } = this.props.app;

        if (modalDialog.dialog === this.component && modalDialog.dialog !== prevProps.app.modalDialog.dialog) {

            this.loadDataRight();
        }
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { modalDialog, path } = this.props.app;
        const { newMeta } = this.state;
        const { classes } = this.props;

        // Allgemeine AG-Grid Konfiguration
        const list = utils.getTree(path, true);
        this.currentProduct = (list.length > 0) ? list[0] : null;

        this.loadDataLeft();

        const dialog = utils.getDialogByPath(path);

        // Allgemeine AG-Grid Konfiguration
        const defaultColDef = {
            sortable: false,
            editable: false,
            filter: false,
            resizable: false,
            enableValue: false,
            enableRowGroup: false,
            enablePivot: false
        }

        const onSave = () => {

            const onUploadSuccess = () => {
                this.props.scanPortfolio(dialog.portfolio);
                this.props.closeModalDialog(); // appAction.js
                setTimeout(() => this.props.setCurrentProduct(this.currentProduct), 200);
            }

            const onUploadError = (error) => { console.log('onUpload() error:', error) }

            newMeta.details = this.dataRight;

            this.props.uploadJSON(path, 'meta.json', newMeta, onUploadSuccess, onUploadError);
        }

        const onCancel = () => {
            this.props.closeModalDialog(); // appAction.js
        }

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderIconBySVG = (props) => {
            const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
            if (!cellValue) return null;

            const src = URL.createObjectURL(new Blob([cellValue], { type: 'image/svg+xml' }));
            return (
                <img src={src} width={32} height={32} title="x" alt="" />
            )
        }

        const renderIconByID = (props) => {
            const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
            if (!cellValue) return null;

            const icon = utils.getIcon(cellValue);
            if (!icon || icon.svg === '') return null;

            const src = URL.createObjectURL(new Blob([icon.svg], { type: 'image/svg+xml' }));
            return (
                <img src={src} width={32} height={32} title="x" alt="" />
            )
        }

        // = LINKE TABELLE ==========================================================
        // 
        // AG-GRID allgemeine Eigenschaften bzw. Liste aller Icons 
        // 
        // ==========================================================================
        const renderIconList = () => {

            // Spalten konfigurieren      
            var agGridNettoWidth = this.agGridLeftWidth * 0.945;

            const columnsDefsLeft = [
                {
                    headerName: "Eigenschaft",
                    field: "label",
                    cellStyle: (params) => {
                        return { textAlign: 'left' };
                    },
                    width: agGridNettoWidth * .60,
                    checkboxSelection: true
                },
                {
                    headerName: "Icon",
                    field: "svg",
                    width: agGridNettoWidth * .26,
                    cellRenderer: "renderIconBySVG",
                },
            ];

            // Daten laden            
            const prepareLeftData = () => {
                this.iconListFiltered.forEach((icon) => {
                    icon['selected'] = false;
                    for (let d of this.dataRight) {
                        if (d.title === icon.label) {
                            icon['selected'] = true;
                        }
                    }
                });

                this.dataLeft = this.iconListFiltered;
            }

            // Initialisierung
            const onGridLeftReady = (params) => {
                this.agGridLeftApi = params.api;
                this.agGridLeftColumnApi = params.columnApi;

                this.agGridLeftApi.forEachNode((node, index) => {
                    if (node.data.selected) {
                        node.setSelected(true);
                    }
                })
            }

            // callbacks
            const onSelectionChanged = (e) => {
                const selectedRows = this.agGridLeftApi.getSelectedRows();

                // Alle selektierten Zeilen/Daten modifiziert übernehmen 
                let newDataRight = [];
                selectedRows.forEach((icon) => {
                    // Feld umbenennen
                    icon['title'] = icon['label'];
                    // Werte aus der rechten Liste in die linke Liste 
                    // übernehmen, sodass dieser dauerhaft erhalten bleibt.
                    for (let d of this.dataRight) {
                        if (d.id === icon.id) icon['value'] = d.value;
                    }
                    // Daten aller selektierter Zeilen übernehmen...
                    // ausser den Feldern: svg, label, type und selected
                    const { svg, label, type, selected, ...newIcon } = icon;

                    newDataRight.push(newIcon);
                })

                this.dataRight = newDataRight;

                this.forceUpdate();
            }

            // ###############################################################
            // renderIconList()
            // ###############################################################
            const height = this.agGridLeftVisibleItems * this.agGridRowHeight + this.agGridHeaderHeight + 1;

            prepareLeftData();

            return (
                <div className="w-full ag-theme-material" style={{ height: height + 'px' }}>
                    <AgGridReact
                        id="myGridReorder"
                        onGridReady={onGridLeftReady}

                        // General definitions
                        sideBar={false}

                        // Column
                        columnDefs={columnsDefsLeft}
                        defaultColDef={defaultColDef}

                        // Row
                        rowData={this.dataLeft}
                        rowHeight={this.agGridRowHeight}
                        rowSelection={"multiple"}
                        onSelectionChanged={onSelectionChanged}
                        rowMultiSelectWithClick={true}
                        rowDragManaged={false}

                        // Header
                        headerHeight={0}

                        // Pagination
                        pagination={false}
                        paginationAutoPageSize={false}
                        suppressScrollOnNewData={false}

                        // Editing
                        singleClickEdit={false}

                        frameworkComponents={{
                            renderIconBySVG: renderIconBySVG
                        }}
                    />
                </div>
            )
        }

        // = RECHTE TABELLE =========================================================
        // 
        // rechtes AG-GRID für Produckt-Eigenschaften
        // 
        // ==========================================================================
        const renderDetailList = () => {

            // Spalten konfigurieren    
            var agGridNettoWidth = this.agGridRightWidth * 0.96;

            const columnsDefsRight = [
                {
                    headerName: "",
                    field: "id",
                    width: 0,
                    editable: false,
                    rowDrag: true
                },
                {
                    headerName: "Eigenschaft",
                    field: "title",
                    type: 'rightAligned',
                    editable: false,
                    width: agGridNettoWidth * .35
                },
                {
                    headerName: "Icon",
                    field: "id",
                    width: agGridNettoWidth * .18,
                    cellRenderer: "renderIconByID",
                    editable: false
                },
                {
                    headerName: "Wert",
                    field: "value",
                    cellStyle: (params) => {
                        return { textAlign: 'left' };
                    },
                    width: agGridNettoWidth * .40,
                    editable: true
                }
            ];

            // Inizalisierung
            const onGridRightReady = (params) => {
                this.agGridRightApi = params.api;
                this.agGridRightColumnApi = params.columnApi;
            }

            // callbacks
            const onChange = () => {
                let detailsNew = [];
                this.agGridRightApi.forEachNode((node) => {
                    detailsNew.push(node.data)
                });
                this.dataRight = detailsNew;
            }


            // ###############################################################
            // renderDetailList()
            // ###############################################################
            const height = this.agGridRightVisibleItems * this.agGridRowHeight + this.agGridHeaderHeight + 1;

            return (
                <div className="w-full ag-theme-material" style={{ height: height + 'px' }}>
                    <AgGridReact
                        id="myGridReorder"
                        onGridReady={onGridRightReady}

                        // General definitions
                        sideBar={false}

                        // Column
                        columnDefs={columnsDefsRight}
                        defaultColDef={defaultColDef}

                        // Row
                        rowData={this.dataRight}
                        rowHeight={this.agGridRowHeight}
                        rowSelection={"single"}
                        rowMultiSelectWithClick={false}
                        onRowDragEnd={onChange}
                        onCellValueChanged={onChange}
                        rowDragManaged={true}

                        // Header
                        headerHeight={this.agGridHeaderHeight}

                        // Pagination
                        pagination={false}
                        paginationAutoPageSize={false}
                        suppressScrollOnNewData={false}

                        // Editing
                        singleClickEdit={false}

                        frameworkComponents={{
                            renderIconByID: renderIconByID
                        }}

                    />
                </div>
            )
        }

        const onChangeTextField = (e) => {
            this.setState({ newMeta: { ...newMeta, [e.target.id]: e.target.value } });
        }

        const getError = () => {
            return { error: false, message: '' }
        }

        const renderTextField = (id, label, type, autoFocus, disabled) => {

            return (
                <TextField
                    autoFocus={autoFocus}
                    id={id}
                    label={label}
                    type={type}
                    fullWidth
                    disabled={disabled}
                    value={newMeta[id]}
                    onChange={onChangeTextField}
                    InputLabelProps={{ shrink: true }}
                    margin="normal"
                    error={getError(id).error}
                    helperText={getError(id).message}
                />
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        if (modalDialog.dialog !== this.component) return null;

        const onSubmit = (e) => {
            e.preventDefault();
        }

        const dialogTitle = 'Eigenschaften';

        return (
            <div>
                <Dialog fullWidth={true} maxWidth="md" open={true} style={{ zIndex: 100 }}>
                    <ModalTitle onClose={onCancel}>{dialogTitle}</ModalTitle>
                    <DialogContent dividers>
                        <Grid container spacing={3}>
                            <Grid item xs={5}>
                                <Paper className={classes.paper}>
                                    {renderIconList()}
                                </Paper>
                            </Grid>
                            <Grid item xs={7}>
                                <form className={classes.form} noValidate onSubmit={onSubmit}>
                                    <FormControl className={classes.formControl}>
                                        {renderTextField('subTitle', 'Untertitel', 'text', true, false)}
                                        {renderTextField('description', 'Beschreibung', 'text', false, false)}
                                        {renderTextField('url', 'Link', 'text', false, false)}
                                    </FormControl>
                                </form>
                                <Paper className={classes.paper}>
                                    {renderDetailList()}
                                </Paper>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onCancel} variant="outlined" color="default" >Abbruch</Button>
                        <Button onClick={onSave} variant="contained" color="primary" >OK</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        icon: state.icon,
        file: state.file,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, iconActions, fileActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ProductDetailsModal));